function getErrorCode(error: unknown): string | undefined {
  return (error as { response?: { data?: { code?: string; error?: { code?: string } } } })?.response?.data?.code
    ?? (error as { response?: { data?: { error?: { code?: string } } } })?.response?.data?.error?.code;
}

export function isCsrfFailure(error: unknown): boolean {
  return getErrorCode(error) === 'CSRF_INVALID';
}

export function isAuthFailure(error: unknown): boolean {
  const status = (error as { response?: { status?: number } })?.response?.status;
  const code = getErrorCode(error);

  if (code === 'CSRF_INVALID') return false;
  if (status !== 401) return false;

  return [
    'AUTH_REQUIRED',
    'TOKEN_INVALID',
    'TOKEN_REUSE_DETECTED',
    'SESSION_INVALID',
    'SESSION_REVOKED',
    'SESSION_EXPIRED',
    'USER_INACTIVE',
  ].includes(code ?? '');
}
